import Editor from '@ckeditor/ckeditor5-core/src/editor';
import React, { FC } from 'react';
import { EditorsObject } from 'components/organisms/ck-collab-editor';
import { PrivateSectionContext } from 'components/organisms/ck-collab-editor/private-section-context';
import { Topbar } from 'components/organisms/document/parts/topbar';
import { Tools } from 'components/organisms/document/parts/topbar/types.d';
import { EditorModes } from 'data/documents';
import { queueMacrotask } from 'utils/macrotask';

export const TemplateDocumentEditorToolbar: FC<{
  activeEditor?: Editor;
  editors?: EditorsObject;
  isPrivateSectionEnabled: boolean;
  readOnly?: boolean;
  title: string;
  onTogglePrivateSection(state: boolean): void;
  tools?: Tools;
}> = ({
  activeEditor,
  editors,
  isPrivateSectionEnabled,
  readOnly,
  title,
  onTogglePrivateSection,
  tools,
}) => {
  return (
    <PrivateSectionContext.Provider
      value={{
        isPrivateSectionEnabled,
        togglePrivateSection: () => {
          onTogglePrivateSection(true);

          queueMacrotask(() => {
            if (editors) {
              editors[EditorModes.Private].editing.view.focus();
            }
          });
        },
      }}
    >
      <Topbar
        topbarClassName="editor__toolbar"
        editor={activeEditor}
        showDocTitle={false}
        docTitle={title}
        readOnly={readOnly}
        tools={tools}
      />
    </PrivateSectionContext.Provider>
  );
};
